module.exports = __webpack_public_path__ + "img/hr-tree-08-a-trunk.725fa296.png";